import {
  EnumerationTrackItDataTypeFilterDto,
  NumericTrackItDataTypeDto,
  EnumerationTrackItDataTypeFilterDtoTypeEnum,
  instanceOfTrackItDataTypeDoubleDto,
  NumericTrackItDataTypeFilterDto,
  NumericTrackItDataTypeFilterDtoTypeEnum,
  TrackItDataTypeBooleanDtoTypeEnum,
  TrackItDataTypeDoubleDtoTypeEnum,
} from '@/api/generator';
import { truthy } from '@/utils/helper';
import { NIL } from 'uuid';

// The evaluation-parameter templates no longer suggest a Track-it filter, so a Track-it task
// starts every new evaluation parameter with an empty one that the tile then fills in.
export function createEmptyNumericTrackItDataTypeFilter(): NumericTrackItDataTypeFilterDto {
  return {
    id: NIL,
    dataType: {
      id: NIL,
      name: '',
      $type: Object.values(TrackItDataTypeDoubleDtoTypeEnum)[0],
    },
    $type: Object.values(NumericTrackItDataTypeFilterDtoTypeEnum)[0],
  };
}

export function createEmptyEnumerationTrackItDataTypeFilter(): EnumerationTrackItDataTypeFilterDto {
  return {
    id: NIL,
    dataType: {
      id: NIL,
      name: '',
      $type: Object.values(TrackItDataTypeBooleanDtoTypeEnum)[0],
    },
    $type: Object.values(EnumerationTrackItDataTypeFilterDtoTypeEnum)[0],
  };
}

export function numericTrackItDataTypeKind(dataType: NumericTrackItDataTypeDto) {
  return instanceOfTrackItDataTypeDoubleDto(dataType) ? 'Double' : 'Long';
}

// "Name | Definition | Type | Unit", skipping empty parts.
export function describeNumericTrackItDataTypeFilter(filter: NumericTrackItDataTypeFilterDto) {
  const dataType = filter.dataType;
  if (!dataType) return '';

  return [dataType.name, dataType.definition, numericTrackItDataTypeKind(dataType), dataType.unit]
    .filter(truthy)
    .join(' | ');
}
